var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('dd', {
    class: _vm._f("twMerge")(['text-base font-normal text-gray-500 mt-1', _vm.className]),
    style: _vm.style
  }, [_vm.withSlotLoading && _vm.isLoading ? [_vm._t("slotLoading")] : _vm.isLoading ? _c('div', [_c('Skeleton', {
    attrs: {
      "className": "w-52 h-5 rounded-md"
    }
  })], 1) : _vm._t("default")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }